module.exports = __webpack_public_path__ + "img/68.56e5bb8b.jpg";